<template>
  <div class="orderManagementClass">
    <div class="orderManagementContent" :style="contentViewHeight">
      <div class="printOrderListBox">
        <div>
          <div class="orderSearchBox">
              <div class="timeSearch">
                  <span style="color: #b2b2b2;">发布时间</span>
                  <el-date-picker
                      v-model="createDateValue"
                      @change="chooseDate"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="—"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                  >
                  </el-date-picker>
              </div>
              <el-input v-model="providersName" clearable placeholder="服务商名称"></el-input>
              <el-select clearable v-model="typeValue" placeholder="服务行业">
                  <el-option
                      :label="item.name"
                      :value="item.uuid" v-for="item in server_printList" :key="item.uuid">
                  </el-option>
              </el-select>
              <el-input
                  clearable
                  v-model="monyeInput"
                  placeholder="服务名称"></el-input>
              <el-select v-model="statusValue" placeholder="状态" clearable>
                  <el-option label="待审核" value="EXAMINE"> </el-option>
                  <el-option label="审核通过" value="PASS"> </el-option>
                  <el-option label="审核拒绝" value="REFUSE"> </el-option>
              </el-select>
              <el-select v-model="isRecommend" placeholder="是否推荐" clearable>
                  <el-option label="是" value="true"></el-option>
                  <el-option label="否" value="false"></el-option>
              </el-select>
              <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
              <el-button type="text" class="resetBtn" @click="resetData">
                  <i class="iconfont icon-qingchushujuku"></i>
                  <span>清除条件</span>
              </el-button>
          </div>
          <div class="orderListTable">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              class="tableContent"
            >
                <el-table-column
                    prop="designer"
                    label="缩略图"
                    header-align="center"
                    show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <img :src="scope.row.urlList[0].urlPath" alt="" v-if="scope.row.urlList.length > 0" />
                    </template>
                </el-table-column>
              <el-table-column
                prop="serviceName"
                label="服务名称"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="serviceTypeName"
                label="服务行业"
                header-align="center"
                align="center"
                show-overflow-tooltip
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="materialTypeName"
                label="打印材料"
                header-align="center"
                show-overflow-tooltip
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="storeName"
                label="服务商"
                header-align="center"
                show-overflow-tooltip
                width="200"
                align="center"
              >
              </el-table-column>
                <el-table-column
                    prop="sort"
                    align="center"
                    header-align="center"
                    label="推荐位" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.recommentedSort===0?'':scope.row.recommentedSort }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="isIssue"
                    label="状态"
                    header-align="center"
                    align="center">
                    <template slot-scope="scope">
                        {{scope.row.examineStatus === 'EXAMINE'?'待审核': scope.row.examineStatus === 'REFUSE'?'审核拒绝':'审核通过'}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="publishDate"
                    label="发布时间"
                    header-align="center"
                    show-overflow-tooltip
                    width="200"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.isIssue === 0?'': scope.row.publishDate }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            v-if="scope.row.examineStatus === 'PASS'"
                            @click="setSortInfo(scope.row)"
                        >推荐位</el-button
                        >
                        <el-button type="text" size="small" v-if="scope.row.examineStatus === 'PASS' && scope.row.recommentedSort" @click="cancelRecommended(scope.row)">取消推荐</el-button>
                        <el-button
                            type="text"
                            size="small"
                            v-if="scope.row.examineStatus === 'EXAMINE'"
                            @click="toDialog(0,scope.row.uuid)"
                        >审核</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            @click="toDialog(1,scope.row.uuid)"
                        >查看</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
              background
              @current-change="handleCurrentChange"
              @prev-click="handleCurrentChange"
              @next-click="handleCurrentChange"
              layout="total,prev, pager, next,jumper"
              :current-page="current"
              :page-size="pageSize"
              :total="total"
              class="pagination"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!--审核查看弹出框-->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="800px"
    >
      <div class="dialogBox">
        <div class="details">
          <div class="detailsItem">
            <h3>服务信息</h3>
            <div class="itemContent">
              <div class="one-row">
                <div class="label">服务名称:</div>
                <div class="name">{{ info.serviceName }}</div>
              </div>
                <div class="two-row">
                    <div class="label">服务价格:</div>
                    <div class="name">{{ info.servicePrice }}元</div>
                </div>
              <div class="two-row">
                <div class="label">服务行业:</div>
                <div class="name">{{ info.serviceTradeName }}</div>
              </div>
              <div class="two-row">
                <div class="label">打印材料:</div>
                <div class="name">{{ info.serviceMaterialName }}</div>
              </div>
              <div class="two-row">
                <div class="label">服务商:</div>
                <div class="name">{{ info.storeName }}</div>
              </div>
              <div class="two-row" style="width:100%">
                <div class="label">服务缩略图:</div>
                <div class="name" v-if="info.urlList">
                    <img :src="info.urlList[0].urlPath" alt="" v-if="info.urlList.length >0">
                </div>
              </div>
                <div class="two-row" style="width:100%">
                    <div class="label">服务详情:</div>
                    <div class="nameimg vHtmlMess" v-html="info.serviceContent"/>
                </div>
            </div>
          </div>
        </div>
        <div class="audit" v-if="currentAudit === 1">
          <h3>审核结果</h3>
          <div class="auditContent">
              <el-tag type="success" effect="dark" v-if="info.examineStatus=='PASS'">审核已通过</el-tag>
              <el-tag type="danger" effect="dark" v-if="info.examineStatus=='REFUSE'">审核已驳回</el-tag>
              <div class="cause" v-if="info.examineStatus=='REFUSE'">
                  <div class="causeTitle">驳回原因：</div>
                  <div class="causeContent">
                      {{ info.remark }}
                  </div>
              </div>
          </div>
        </div>
        <div class="audit" v-if="currentAudit === 0">
          <h3>审核</h3>
          <div class="auditContent">
            <el-radio-group v-model="auditRadio">
                <el-radio label="PASS">通过</el-radio>
                <el-radio label="REFUSE">驳回</el-radio>
            </el-radio-group>
              <div class="cause" v-if="auditRadio === 'REFUSE'">
                  <div class="causeTitle">驳回原因：</div>
                  <div class="causeContent" style="width: 100%">
                      <el-input
                          type="textarea"
                          :autosize="{ minRows: 5 }"
                          placeholder="请输入驳回原因"
                          v-model="textarea"
                      >
                      </el-input>
                  </div>
              </div>
            <div class="auditEnter">
              <el-button type="primary" @click="auditSubmit">确定</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
      <!-- 设置推荐位 -->
      <el-dialog
          title="设置推荐位"
          :visible.sync="sortDialogVisible"
          width="800px">
          <div class="dialogContent">
              <el-form :rules="rules" :model="ruleForm" ref="ruleForm" label-width="120px">
                  <el-form-item prop="sort" label="推荐位">
                      <el-input-number v-model="ruleForm.sort"  :min="1"></el-input-number>
                  </el-form-item>
                  <el-form-item class="submitButtonClass">
                      <el-button type="primary" @click="submit">提交</el-button>
                  </el-form-item>
              </el-form>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import { getDictionaryItem,examineServiceability,
    getServiceabilityDetail,getServiceabilityList, setServiceSort } from '../../../utils/interface';
export default {
  name: "serverAudit",
  data() {
    return {
        providersName:"",
        isRecommend:null,
        startTime:"",
        endTime:"",
        createDateValue: null,
        typeValue: "",
        statusValue: "",
        monyeInput: "",
        server_printList:"",
        tableData: [],
        current: 1,
        pageSize: 10,
        total: 0,
        dialogVisible: false,
        title: "",
        auditRadio: "",
        textarea: "",
        currentAudit: "",
        sortDialogVisible:false,
        ruleForm:{
            sort:'',
        },
        rules: {
            sort: [
                {required: true, message: '请设置推荐排序', trigger: 'change'}
            ],
        },
        info:{},
    };
  },
    created(){
      this.getList();
      this.getDictionaryItem('server_print')
    },
  computed: {
    contentViewHeight() {
      let height = document.documentElement.clientHeight - 120;
      return { minHeight: height + "px" };
    },
  },
  methods: {
      // 时间格式
      chooseDate(){
          this.startTime = "";
          this.endTime = "";
          // 判断时间
          if(this.createDateValue!=null && this.createDateValue.length==2){
              this.startTime = this.timeDate(this.createDateValue[0]);
              this.endTime = this.timeDate(this.createDateValue[1]);
          }
      },
      timeDate(value){
          let date = new Date(value);
          let y = date.getFullYear();
          let MM = date.getMonth() + 1;
          MM = MM < 10 ? "0" + MM : MM;
          let d = date.getDate();
          d = d < 10 ? "0" + d : d;
          return y + "-" + MM + "-" + d;
      },
      submit(){
          this.info.sort = this.ruleForm.sort;
          setServiceSort({uuid:this.info.uuid,sort:this.ruleForm.sort}).then((res)=>{
              if(res.success) {
                  this.$message.success('设置成功！');
                  this.sortDialogVisible = false;
                  this.getList();
              }
          });
      },
      cancelRecommended(item){
          this.$confirm('确定取消推荐吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              setServiceSort({uuid:item.uuid,sort:-1}).then((res)=>{
                  if(res.success) {
                      this.$message.success('设置成功！');
                      this.sortDialogVisible = false;
                      this.getList();
                  }
              });
          }).catch(() => {})
      },
      setSortInfo(item){
          this.info = item;
          if(item.sort!=""){
              this.ruleForm.sort = item.recommentedSort;
          }
          this.sortDialogVisible = true;
      },
      searchInfo(){
        this.current = 1;
        this.getList();
      },
      // 获取字典值
      getDictionaryItem(val){
          getDictionaryItem({groupCode: val}).then((res)=>{
              if(val === 'server_print'){
                  this.server_printList = res
              }
          })
      },
      getList(){
          let params = {
              serviceId:this.typeValue,
              serviceName:this.monyeInput,
              examineStatus:this.statusValue,
              startDate:this.startTime,
              endDate:this.endDate,
              providersName:this.providersName,
              isRecommend:this.isRecommend,
              current:this.current,
              pageSize:this.pageSize
          };
          getServiceabilityList(params).then((res)=>{
              res.list.map((item)=>{
                  let serviceInfo = "";
                  let tradeList = item.tradeList;
                  if(tradeList.length > 0){
                      for(let i=0;i<tradeList.length;i++){
                          serviceInfo += ","+tradeList[i].serviceabilityTradeName;
                      }
                  }
                  let materialInfo = "";
                  let materialList = item.materialList;
                  if(materialList.length > 0){
                      for(let i=0;i<materialList.length;i++){
                          materialInfo += ","+materialList[i].printMaterialName;
                      }
                  }
                  this.$set(item,'serviceTypeName',serviceInfo.substring(1));
                  this.$set(item,'materialTypeName',materialInfo.substring(1));
              });
              this.tableData = res.list;
              this.current = res.current;
              this.pageSize = res.size;
              this.total = res.total;
          });
      },
    resetData() {
        this.providersName = "";
        this.startTime = "";
        this.endTime = "";
        this.createDateValue = null;
        this.typeValue = "";
        this.statusValue = "";
        this.monyeInput = "";
        this.isRecommend=null;
        this.searchInfo()
    },
    // 分页
    handleCurrentChange(val) {
      this.current = val;
      this.getList();
    },
    // 审核查看
    toDialog(val,uuid) {
      this.info = {};
      this.dialogVisible = true;
      this.currentAudit = val;
      if (val === 0) {
        this.title = "审核详情";
        this.auditRadio = "";
        this.textarea = "";
      } else {
        this.title = "查看详情";
      }
      getServiceabilityDetail({uuid:uuid}).then((res)=>{
         this.info = res.data;
      });
    },
    // 确定审核
    auditSubmit() {
      if (this.auditRadio === "") {
        this.$message.warning("请选择审核结果！");
      } else if (this.auditRadio === "REFUSE" && this.textarea === "") {
        this.$message.warning("请输入驳回原因！");
      } else {
          let params = {
              uuid:this.info.uuid,
              examineStatus:this.auditRadio,
              remark:this.textarea
          };
          examineServiceability(params).then((res)=>{
              this.$message.success("审核成功！");
              this.dialogVisible = false;
              this.getList();
          });
      }
    },
  },
};
</script>

<style scoped lang="less">
.orderManagementClass {
  position: relative;
  width: 100%;
  padding: 0 20px 20px;
  .orderManagementContent {
    background: #fff;
    .printOrderListBox {
      padding: 20px;
        .orderSearchBox {
            .timeSearch {
                background-color: #f2f4f7;
                height: 35px;
                display: flex;
                align-items: center;
                margin-bottom: 22px;
                margin-right: 30px;
                border-radius: 8px;

                span {
                    font-size: 12px;
                    color: #c0c4cc !important;
                    font-weight: normal;
                    padding-left: 15px;
                    margin-right: 5px;
                }

                // /deep/ .el-range-input{
                //         background-color: #f2f4f7;
                //             &:hover, &:focus {
                //             background-color: #fff;
                //             // border: 1px solid #108EE9;
                //         }
                // }
                /deep/ input::-webkit-input-placeholder {
                    color: #c0c4cc;
                    font-size: 12px;
                }

                /deep/ .el-range-input:hover {
                    background-color: #fff !important;
                }

                /deep/ .el-date-editor .el-range-separator {
                    line-height: 25px;
                    color: #c0c4cc;
                }

                /deep/ .el-date-editor .el-range__close-icon {
                    line-height: 28px;
                }

                /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                    background-color: white;
                }

                /deep/ .el-input__inner {
                    width: 225px;
                    height: 35px;
                    min-height: 35px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                    border: 1px solid #f2f4f7;
                    border-radius: 5px;

                    .el-range-input {
                        background-color: #f2f4f7;
                    }

                    &:hover, &:focus {
                        background-color: #fff;
                        border: 1px solid #108EE9;

                    }
                }
            }
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }

      .tableContent {
        min-height: 600px;

        /deep/ .el-table__header {
          tr {
            th {
              border-right: none;
            }
          }

          /deep/ .el-table__cell {
            padding: 5px 0;
            background: #f2f5fc;
          }
        }

        /deep/ .el-table__body {
          img {
            vertical-align: middle;
            width: 52px;
            height: 50px;
          }
        }
      }

      .pagination {
        margin-top: 20px;
        text-align: right;
      }
    }
  }

  //审核查看详情中title的样式
/deep/.el-dialog__header{
    border-bottom: 1px solid #ddd;
   .el-dialog__title{
    color: #000;
    font-weight: 700;
    font-size: 16px;

  }
}

  .dialogBox {
    .details {
      .detailsItem {
        padding-bottom: 20px;
        h3 {
          font-weight: 700;
          font-size: 16px;
          color: #000;
          margin-top: 0;
          letter-spacing: 1px;
          // border-bottom: 1px solid #ddd;
          padding-bottom: 15px;
        }
        .itemContent {
          display: flex;
          flex-wrap: wrap;
          font-size: 15px;
          // padding: 0 30px;
          .one-row {
            width: 50%;
            margin-bottom: 22px;
            display: flex;
            font-size: 14px;
            .label {
              padding-right: 15px;
              min-width: 95px;
              color: rgba(0, 0, 0, 0.85);
            }
            .name {
              // color: #000;
              color: rgba(0, 0, 0, 0.65);
            }
          }
         /deep/ .nameimg{
              img{
                width: 100%;
              }
          }
          .two-row {
            width: 50%;
            margin-bottom: 22px;
            display: flex;
            .label {
              padding-right: 15px;
              min-width: 95px;
              color: rgba(0, 0, 0, 0.85);
            }
            .name {
              // color: #000;
              color: rgba(0, 0, 0, 0.65);
              img {
                  width: 216px;
              }
            }
          }
        }
        .itemPictureContent {
          display: flex;
          flex-wrap: wrap;
          font-size: 15px;
          padding: 0 30px;
          justify-content: space-between;
          .one-row {
            width: 30%;
            margin-bottom: 22px;
            img {
              width: 100%;
              height: 138px;
              border: 1px solid #ddd;
            }
            .name {
              text-align: center;
              padding-top: 10px;
              font-size: 14px;
              display: flex;
              .label {
                min-width: 80px;
              }
            }
          }
        }
      }
    }
    .audit {
      padding-bottom: 20px;
      h3 {
        font-weight: 700;
        font-size: 16px;
        color: #000;
        margin-top: 0;
        letter-spacing: 1px;
        // border-bottom: 1px solid #ddd;
        padding-bottom: 15px;
      }
      .auditContent {
        // padding: 0 30px;
      }
      .cause {
        display: flex;
        margin-top: 20px;
        .causeTitle {
          min-width: 80px;
          color: #3a8ee6;
        }
        .causeContent {
          color: #000;
        }
      }
      .auditEnter {
        text-align: center;
        padding-top: 20px;
        button {
          width: 120px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auditManagement/printAudit/serverAudit.vue